import * as z from 'zod';
import { ColorThemeEnum } from '@/enum/ColorThemeEnum';
import { WaveWrapperModeEnum, getWaveWrapperModeValues } from '@/enum/WaveWrapperModeEnum';
import { getWaveShapeValues } from '@/enum/WaveShapeEnum';

const WaveWrapperZod = z.object({
  id: z.number(),
  color: z.enum([
    ColorThemeEnum.ORANGE,
    ColorThemeEnum.ORANGE_REVERT,
    ColorThemeEnum.BLUE,
    ColorThemeEnum.BLUE_REVERT,
    ColorThemeEnum.DARKBLUE,
    ColorThemeEnum.DARKBLUE_REVERT,
    ColorThemeEnum.PURPLE,
    ColorThemeEnum.PURPLE_REVERT,
    ColorThemeEnum.GREEN,
    ColorThemeEnum.GREEN_REVERT,
    ColorThemeEnum.WHITE,
  ]),
  variant: z.enum(getWaveShapeValues()),
  mode: z.enum(getWaveWrapperModeValues()).nullable().default(WaveWrapperModeEnum.WRAPPED),
});

export { WaveWrapperZod };
export type WaveWrapperType = z.infer<typeof WaveWrapperZod>;
